var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "arrow-right-hover.610a3c4f.png","uri@2x": __webpack_public_path__ + "arrow-right-hover.2413e203.png","uri@3x": __webpack_public_path__ + "arrow-right-hover.e64627b7.png",
    width: 18,
    height: 12
});